// In production, always use same-origin (/api/* goes through Cloudflare Pages Functions).
// In development, default to localhost backend when REACT_APP_API_BASE is not set.
const isProd = process.env.NODE_ENV === 'production';
const API_BASE = isProd
  ? ''
  : (process.env.REACT_APP_API_BASE !== undefined
    ? process.env.REACT_APP_API_BASE
    : 'http://localhost:4000');

export async function getAuthHeaders(getToken) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken && (typeof getToken === 'function' ? await getToken() : getToken);
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export async function apiGet(path, getToken) {
  const headers = await getAuthHeaders(getToken);
  const res = await fetch(`${API_BASE}${path}`, { headers });
  return res;
}

export async function apiPost(path, body, getToken) {
  const headers = await getAuthHeaders(getToken);
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers,
    body: typeof body === 'string' ? body : JSON.stringify(body),
  });
  return res;
}

function buildOwnershipXmlPath({ KodKU, CisloLv, userId, refresh = false, confirmPaidRefresh = false }) {
  const params = new URLSearchParams({
    KodKU: String(KodKU ?? '').trim(),
    CisloLv: String(CisloLv ?? '').trim(),
  });
  if (userId) params.set('user_id', String(userId).trim());
  if (refresh) params.set('refresh', '1');
  if (confirmPaidRefresh) params.set('confirm_paid_refresh', '1');
  return `/api/ownership-xml?${params.toString()}`;
}

async function readJsonSafe(res) {
  return res.json().catch(() => ({}));
}

export async function apiGetOwnershipXml({
  KodKU,
  CisloLv,
  getToken,
  userId,
  confirmMessage = 'This action may incur a paid ČÚZK fetch (100 CZK). Continue?',
  allowPaidFetch = true,
}) {
  const firstPath = buildOwnershipXmlPath({ KodKU, CisloLv, userId });
  const firstRes = await apiGet(firstPath, getToken);
  const firstData = await readJsonSafe(firstRes);

  if (firstRes.ok) {
    return { res: firstRes, data: firstData, paidRefreshUsed: false };
  }

  const code = String(firstData?.code || '').trim();
  const needsPaidRefresh = code === 'CACHE_MISS' || code === 'PAID_REFRESH_CONFIRM_REQUIRED';
  if (!allowPaidFetch || !needsPaidRefresh) {
    return { res: firstRes, data: firstData, paidRefreshUsed: false };
  }

  const ok = window.confirm(confirmMessage);
  if (!ok) {
    return { res: firstRes, data: firstData, paidRefreshUsed: false, cancelledPaidRefresh: true };
  }

  const refreshPath = buildOwnershipXmlPath({
    KodKU,
    CisloLv,
    userId,
    refresh: true,
    confirmPaidRefresh: true,
  });
  const refreshRes = await apiGet(refreshPath, getToken);
  const refreshData = await readJsonSafe(refreshRes);
  return { res: refreshRes, data: refreshData, paidRefreshUsed: true };
}

export { API_BASE };
